import { useEffect, useState } from 'react';
import { imageSrc } from '../api/media';

function initial(name: string): string {
  return name.trim().slice(0, 1).toUpperCase() || '?';
}

interface Props {
  avatarFileId?: string | null;
  name: string;
  size?: number;
}

/** Аватар комнаты (темы) группового чата — картинка через общий media/{id} (imageSrc), как и
 *  у других загруженных файлов; в отличие от Avatar.tsx нет отдельного /rooms/{id}/avatar
 *  endpoint — комнат в чате может быть много, отдельный HTTP-роут на каждую того не стоит,
 *  ChatRoomDto уже приносит сам avatarFileId. Без своей картинки — цветной кружок с первой
 *  буквой названия (тот же паттерн, что и у Avatar.tsx для пользователей/групп). */
export default function RoomAvatar({ avatarFileId, name, size = 20 }: Props) {
  const [src, setSrc] = useState<string | null>(null);
  useEffect(() => {
    let alive = true;
    setSrc(null);
    if (avatarFileId) {
      imageSrc(avatarFileId).then((u) => alive && setSrc(u)).catch(() => {});
    }
    return () => {
      alive = false;
    };
  }, [avatarFileId]);
  return (
    <div className="avatar room-avatar" style={{ width: size, height: size, fontSize: Math.round(size * 0.5) }}>
      {src ? <img src={src} alt="" className="avatar-img" /> : initial(name)}
    </div>
  );
}
